import ActivityCreateModal from './activity-create-modal-container'
export default ActivityCreateModal
